import React from "react";
import Modal from "react-bootstrap/Modal";
import styled from "styled-components";
import { connect } from "react-redux";
import { setWelcomeShown, setVersionNumber } from "../login/userSession.redux";

const StyledHeader = styled(Modal.Header)`
  border-bottom: transparent;
  background: ${(p) => p.theme.color.surfaceAlt};
`;

const StyledBody = styled(Modal.Body)`
  border-bottom: transparent;
  background: ${(p) => p.theme.color.surfaceAlt};
  padding: 0 ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.md};
  height: 60vh;
  overflow-y: auto;
`;

const VersionTitle = styled.div`
  margin-bottom: 1em;
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeXl};
  font-weight: ${(p) => p.theme.font.weightSemibold};
  color: ${(p) => p.theme.color.primary};
`;

const ModalRedux = (props) => {
  const {
    welcomeShown,
    showPatchNotes,
    patchNotes,
    welcomePost,
    setWelcomeShown,
    setVersionNumber,
    versionNumber,
  } = props;

  const preprocessPatchNotes = (html) =>
    html.replace(/data-src=/g, "src=").replace(/data-srcset=/g, "srcset=");

  const getPatchNotesHtml = () =>
    patchNotes.map(({ content, title }) => (
      <>
        <VersionTitle
          dangerouslySetInnerHTML={{ __html: title.rendered }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: preprocessPatchNotes(content.rendered),
          }}
        />
      </>
    ));

  const preprocessWelcomePost = (html) => html.replace(/data-src=/g, "src=");

  const getWelcomePostHtml = () => (
    <>
      <VersionTitle
        dangerouslySetInnerHTML={{ __html: welcomePost.title.rendered }}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: preprocessWelcomePost(welcomePost.content.rendered),
        }}
      />
    </>
  );

  const handleClose = () => {
    if (!welcomeShown) {
      window.localStorage.setItem("welcomeShown", true);
      setWelcomeShown({ welcomeShown: true });
    }
    if (welcomeShown && showPatchNotes) {
      window.localStorage.setItem("versionNumber", versionNumber);
      setVersionNumber({ versionNumber });
    }
  };

  return (
    <Modal
      size="lg"
      show={false}
      onHide={handleClose}
      centered
      className="session-modal"
    >
      <StyledHeader closeButton />
      <StyledBody>
        {welcomeShown && showPatchNotes && getPatchNotesHtml()}
        {!welcomeShown && getWelcomePostHtml()}
      </StyledBody>
    </Modal>
  );
};

export const ModalSession = connect(
  (state) => ({
    welcomeShown: state.userSession.welcomeShown,
    showPatchNotes: state.userSession.showPatchNotes,
    patchNotes: state.userSession.patchNotes,
    welcomePost: state.userSession.welcomePost,
    versionNumber: state.userSession.versionNumber,
  }),
  { setWelcomeShown, setVersionNumber },
)(ModalRedux);
